export const MY_FLIGHT_PANEL = 'myFlightPanel';
export const TODAY_PANEL = 'todayPanel';
export const PROFILE_SELECTOR = 'profileSelector';
export const NOTIFICATION = 'notification';
export const INTERSTITIAL_BANNER = 'interstitialBanner';
export const BOOK = 'book';
export const MY_TRIPS = 'my_trips';
export const MIN_AIRPORT_SEARCH_LENGTH = 3;
export const PARAM_1 = '{param1}';
